import React from 'react';
import './AddressButton.css';

const AddressButton = ({ icon, text, color, onClick }) => {
    return (
        <button 
            className="address-button"
            onClick={onClick}
            style={{ backgroundColor: color }}
        >
            {icon}
            {text}
        </button>
    );
};

export default AddressButton; 